var app = angular.module("leonardo");

var UserListActions = function ($scope, ngDialog, PermissionService, AuthDataService, FilterService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;

  $scope.showExportUsers = function () {
    var filters = {
      // user_search: FilterService.getFilter('user_search'),
      // active: FilterService.getFilter('active'),
      // role: FilterService.getFilter('role'),
      // managed_by: FilterService.getFilter('managed_by_reports'),
      // account: FilterService.getFilter('account_reports'),
      // portfolio: FilterService.getFilter('portfolio_reports'),
      // property: FilterService.getFilter('property_reports')
    };
    ngDialog.open({
      template: 'views/templates/dialog/account-user/export.html',
      controller: 'ExportUsersDialog',
      data : {
        filters : filters
      }
    });
  };

};

app.controller('UserListActions', ['$scope', 'ngDialog', 'PermissionService', 'AuthDataService', 'FilterService',
  UserListActions]);
